import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Gift } from 'lucide-react';
import { apiService } from '../services/apiService';

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [hasVoucherBonus, setHasVoucherBonus] = useState(false);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      apiService.checkSessionVoucher(sessionId)
        .then(res => setHasVoucherBonus(res.hasVoucherBonus))
        .catch(() => {});
    }
  }, [searchParams]);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/plans');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 rounded-full p-4">
            <CheckCircle className="h-16 w-16 text-green-600" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Subscription Activated!
        </h1>

        <p className="text-gray-600 mb-6">
          Your subscription has been successfully activated. You now have access to your monthly quota and discounted rates.
        </p>

        {hasVoucherBonus && (
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 mb-6 text-left">
            <div className="flex items-start gap-3">
              <Gift className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-semibold text-indigo-900 mb-1">Thank you for subscribing with a voucher!</p>
                <p className="text-sm text-indigo-700">
                  As a token of gratitude, we've added <span className="font-semibold">$5 in free credits</span> to your account. These can be used towards AI response costs.
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-800">
            Your quota will be available immediately. You'll be redirected to your dashboard in a few seconds.
          </p>
        </div>

        <button
          onClick={() => navigate('/plans')}
          className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          View Plans & Billing
        </button>
      </div>
    </div>
  );
}
